var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"global-overlay"},[_c('div',{staticClass:"loading-spinner"},[_c('i',{staticClass:"fas fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }